import axios from 'axios';
import { Component } from 'san';
import toasterService from 'src/services/toaster.service';
import uploaderService from 'src/services/uploader.service';
import * as _ from 'lodash';
import * as moment from 'moment';

export default class UpdateAuthLicense extends Component {
    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;
        licenseInfo: any;
        file: any;
        expirationTime: string;
        callback: any;
        secretProjectFeatureEnabled: boolean;
    } {
        return {
            isShow: false,
            licenseInfo: null,
            file: undefined,
            expirationTime: '',
            callback: undefined,
            secretProjectFeatureEnabled: false,
        };
    }

    attached() {
        this.initUploader();
    }

    initUploader() {
        uploaderService.show({
            isMultiple: false,
            selector: '#uploadLicense',
            server: '/api/setup/check-license',
            queuedCallback: (file => {
                this.data.set('file', file);
            }),
            errorCallback: (response: any) => {
                this.data.set('licenseInfo', null);
                toasterService.show({
                    type: 'danger',
                    title: response.message,
                    contents: response.errors
                });
            },
            finishedCallback: (result) => {
                if(!result[0]) {
                    return;
                }
                if (result[0].is_valid) {
                    if(!_.isUndefined(result[0].features.SecretProjectFeatureEnabled)) {
                        this.data.set('secretProjectFeatureEnabled', JSON.parse(result[0].features.SecretProjectFeatureEnabled + ''));
                    }
                    this.data.set('licenseInfo', result[0]);
                    const date = result[0].expiration_time.slice(0, 10);
                    const expirationTime = _.split(date, '-')[0] === '9999' ? '永久' : moment(date).format('YYYY年MM月DD日');
                    this.data.set('expirationTime', expirationTime);
                }
            }
        });
    }

    show(callback) {
        this.data.set('isShow', true);
        this.data.set('callback', callback);
    }

    cancel() {
        this.data.set('isShow', false);
        this.data.set('licenseInfo', null);
        this.data.set('expirationTime', '');
        this.data.set('callback', null);
        this.data.set('secretProjectFeatureEnabled', false);
    }

    upload() {
        if (this.data.get('file')?.id) {
            uploaderService.removeFile(this.data.get('file').id);
        }
        const uploadEle = $(`#uploadLicense input[type='file']`);
        uploadEle.click();
    }

    submit() {
        const data = new FormData();
        data.append("file", this.data.get('file').source.source);
        axios.post("/api/setup/license", data).then(() => {
            const callback = this.data.get('callback');
            if (callback) {
                callback();
            }
            this.cancel();
        });
    }
}